module.exports = __webpack_public_path__ + "img/icon-price-over.e01c6807.svg";